<app-scrollable-dialog headerKey="button.sendInvites">
  <ng-container content>
    <h2>{{ 'user.bulkInviteHeader' | loc }}</h2>
    <app-search-field [(search)]="tableSearch"> </app-search-field>
    <app-clickable-row-table
      [data]="tableData"
      [config]="tableConfig"
      [pageIndex]="tablePage$"
      [search]="tableSearch"
      [loaded]="true"
      [templateRef]="rows"
      [headerRef]="header"
    >
      <ng-template #header let-column="column">
        <ng-container [ngSwitch]="column.value">
          <ng-container *ngSwitchCase="'id'">
            <mat-checkbox
              [checked]="resToInvite.length == tableData.length"
              [indeterminate]="resToInvite.length != tableData.length && resToInvite.length != 0"
              (change)="checkAll($event.checked)"
            ></mat-checkbox>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="templateService.defaultRowTableHeader; context: { column: column }"> </ng-container>
          </ng-container>
        </ng-container>
      </ng-template>
      <ng-template #rows let-element="element" let-column="column">
        <ng-container [ngSwitch]="column.value">
          <td class="mat-cell" *ngSwitchCase="'id'">
            <mat-checkbox
              [ngModel]="element.checked"
              (ngModelChange)="onResidentSelected(element.id.value, $event)"
              color="primary"
              [disabled]="!element.phone.isValid || element.invited"
              [matTooltip]="
                (element.phone.isValid ? (element.invited ? 'appInvite.sendTT' : '') : 'user.inviteInvalidPhone') | loc
              "
            ></mat-checkbox>
          </td>
          <td class="mat-cell" *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="templateService.defaultRowTable; context: { cell: element[column.value] }">
            </ng-container>
          </td>
        </ng-container>
      </ng-template>
    </app-clickable-row-table>
  </ng-container>
  <ng-container actions>
    <ng-container *ngIf="!isSubmitting; else templateService.loader">
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="resToInvite.length == 0">
        {{ 'button.send' | loc }}
      </button>
      <button mat-stroked-button [mat-dialog-close]="false">{{ 'button.cancel' | loc }}</button>
    </ng-container>
  </ng-container>
</app-scrollable-dialog>
